<template>
    <div id="lkpKannattavuusLaskuri" v-if="contentServiceUrlLoaded">
        <LKPKannattavuuslaskuri />
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator"
    import LKPKannattavuuslaskuri from "@/components/LKPKannattavuuslaskuri.vue"

    @Component({
        components: {
            LKPKannattavuuslaskuri
        }
    })
    export default class LKPKannattavuuslaskuriPage extends Vue {
        get contentServiceUrlLoaded(): boolean {
            return this.$store.getters.contentServiceUrl.length > 0
        }
    }
</script>
